import { render, staticRenderFns } from "./smart-title.vue?vue&type=template&id=0ff84965&scoped=true"
import script from "./smart-title.vue?vue&type=script&lang=js"
export * from "./smart-title.vue?vue&type=script&lang=js"
import style0 from "./smart-title.vue?vue&type=style&index=0&id=0ff84965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff84965",
  null
  
)

export default component.exports